import SrPdfGenerator from 'client/pages/SrPdfGenerator/SrPdfGenerator';

export default SrPdfGenerator;
